import type { DataGridDataRowTemplateProps, RowTemplateType } from '@myosh/odin-components';
import type { ReactNode } from 'react';
import useDoubleClick from '../../hooks/use-double-click';
import { forceAssert } from '../../utils/type-guards';
import { RecordTitle } from '../record/record-title.component';
import { returnRecordTitle } from './odin-data-grid-row-template.component';
import type { OdinDataGridRowTemplateProps } from './odin-data-grid-row-template.component';

export const ActivitiesPageRecordRowProps = {
  id: 'id',
  moduleId: 'moduleId',
  formName: 'formName',
  docNo: 'docNo',
  status: 'status',
  date: 'lastModifiedDateTime',
  vikingLinkUrl: 'vikingLinkUrl',
} as const;
export type ActivitiesPageRecordRowProps =
  (typeof ActivitiesPageRecordRowProps)[keyof typeof ActivitiesPageRecordRowProps];

export function MyActivitiesDataGridRowTemplate({
  modules,
  activeRecordReference,
  recordFields = ActivitiesPageRecordRowProps,
}: OdinDataGridRowTemplateProps) {
  const { rowClickHandler } = useDoubleClick();

  const rowTemplate: RowTemplateType = (
    props: DataGridDataRowTemplateProps,
    children: ReactNode | Array<ReactNode>
  ) => {
    const module = modules?.find(
      (item: unknown) => forceAssert<{ id: number }>(item).id === props.data[recordFields?.moduleId]
    );

    if (module) {
      const date = new Date(props.data[recordFields.date as string] as string | Date);
      const title = returnRecordTitle(props, recordFields);
      const details = <RecordTitle title={title} date={date} />;

      const handleClick = (isFullScreen: boolean) => {
        const recordId = props.data[recordFields.id];
        activeRecordReference?.current?.addActiveRecord(String(recordId), module.icon, details, isFullScreen, {
          title,
          recordId: recordId,
          viewId: module.viewId,
          moduleIcon: module.icon,
          formId: props.data.formId,
          formName: props.data[recordFields.formName],
          docNo: props.data[recordFields.docNo],
          status: props.data[recordFields.status],
          vikingLinkUrl: recordFields.vikingLinkUrl ? props.data[recordFields.vikingLinkUrl] : undefined,
          displayText: recordFields.displayText ? props.data[recordFields.displayText] : undefined,
        });
      };

      const handleRowClick = () => {
        rowClickHandler(handleClick);
      };

      return (
        <div className="flex w-full cursor-pointer" onClick={handleRowClick}>
          {children}
        </div>
      );
    } else {
      return <>{children}</>;
    }
  };
  return rowTemplate;
}
